<template>
  <Layout class="main">
    <Sider
      class="left_menu"
      ref="leftSide"
      hide-trigger
      collapsible
      :collapsed-width="78"
      v-model="isCollapsed"
      :width="210"
    >
      <side-menu
        accordion
        ref="sideMenu"
        :active-name="routerName"
        :collapsed="isCollapsed"
        @on-select="turnToPage"
        :menu-list="menuList"
      >
        <div class="logo_con">
          <img v-show="!isCollapsed" src="../../assets/images/logo.png" key="max-logo" />
          <img v-show="isCollapsed" src="../../assets/images/logo1.png" key="min-logo" />
        </div>
      </side-menu>
    </Sider>
    <Layout>
      <Header :style="{ padding: 0 }" class="layout-header-bar">
        <header-bar :collapsed="isCollapsed" @on-coll-change="handleCollapsedChange">
          <user :userName="userName" />
        </header-bar>
      </Header>
      <Content class="main_content">
        <Layout>
          <div class="tag_wrap">
            <tags-nav
              :value="$route"
              @input="handleClick"
              :list="tagNavList"
              @on-close="handleCloseTag"
            />
          </div>
          <div class="content_wrap">
            <div
              style="
                min-height: 100%;
                background: #fff;
                border: 1px solid #ececec;
              "
            >
              <keep-alive :include="cacheList">
                <router-view :key="$route.fullPath" />
              </keep-alive>
            </div>
          </div>
        </Layout>
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import '@/assets/css/iconfont/iconfont.css'
import TagsNav from './components/tags-nav/tags-nav.vue'
import HeaderBar from './components/header-bar'
import SideMenu from './components/side-menu'
import User from './components/user'
import { mapMutations } from 'vuex'
import { getNewTagList, getNextRoute, routeEqual } from '@/libs/util'
import routers from '@/router/routers'
import cookies from '@/libs/util.cookies.js'
import { getMenuList } from '@/api/user'
export default {
  name: 'Main',
  components: {
    TagsNav,
    SideMenu,
    HeaderBar,
    User
  },
  data () {
    return {
      isCollapsed: false,
      routerName: '',
      menuList: [],
      userName: ''
    }
  },
  computed: {
    tagNavList () {
      return this.$store.state.app.tagNavList
    },
    tagRouter () {
      return this.$store.state.app.tagRouter
    },
    cacheList () {
      return [
        ...(this.tagNavList.length
          ? this.tagNavList
            .filter(item => !(item.meta && item.meta.notCache))
            .map(item => item.name)
          : [])
      ]
    }
  },
  watch: {
    $route (newRoute) {
      const { name, query, params, meta } = newRoute
      this.addTag({
        route: { name, query, params, meta },
        type: 'push'
      })
      this.setBreadCrumb(newRoute)
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
      this.getIsdetail()
      this.$refs.sideMenu.updateOpenName(newRoute.name)
    }
  },
  mounted () {
    this.routerName = ''
    this.userName = cookies.get('userName')
    this.getMenuList()
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList()
    this.setHomeRoute(routers)
    this.addTag({
      route: this.$store.state.app.homeRoute
    })
    this.setBreadCrumb(this.$route)
    // 如果当前打开页面不在标签栏中，跳到homeName页
    if (!this.tagNavList.find(item => item.name === this.$route.name)) {
      this.$router.push({
        name: this.$config.homeName
      })
    }
  },
  methods: {
    ...mapMutations([
      'setBreadCrumb',
      'setTagNavList',
      'addTag',
      'setHomeRoute'
    ]),
    getMenuList () {
      getMenuList()
        .then(res => {
          this.menuList = this.handleMenuList(res.data.menu)
          this.$nextTick(() => {
            this.getIsdetail()
          })
          localStorage.setItem('authList', res.data.authPageUrlList)
        })
        .catch(e => {
          console.log(e)
        })
    },
    // 获取是否是详情页
    getIsdetail () {
      if (this.$route.meta && this.$route.meta.isDetail) {
        if (typeof this.$route.meta.isDetail === 'function') {
          this.routerName = this.$route.meta.isDetail(this.$route)
        } else {
          this.routerName = this.$route.meta.isDetail
        }
      } else {
        this.routerName = this.$route.name
      }
    },
    turnToPage (route) {
      let { name, params, query } = {}
      if (typeof route === 'string') name = route
      else {
        name = route.name
        params = route.params
        query = route.query
      }
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1])
        return
      }
      this.$router.push({
        name,
        params,
        query
      })
    },
    handleCollapsedChange (state) {
      this.isCollapsed = state
    },
    handleCloseTag (res, type, route) {
      if (type === 'all') {
        this.turnToPage(this.$config.homeName)
      } else if (routeEqual(this.$route, route)) {
        if (type !== 'others') {
          const nextRoute = getNextRoute(this.tagNavList, route)
          this.$router.push(nextRoute)
        }
      }
      this.setTagNavList(res)
    },
    handleClick (item) {
      this.turnToPage(item)
    },
    handleMenuList (array) {
      let arr = []
      if (!!array && array.length !== 0) {
        array.forEach(item => {
          let obj = {}
          obj.icon = item.pageIcon
          obj.meta = { title: item.pageName }
          obj.name = item.pageUrl
          if (item.pageUrl.indexOf('admin') > 0) {
            let a = item.pageIcon.slice(0, 1)
            obj.name = a.toUpperCase() + item.pageIcon.slice(1)
          }
          if (item.pages.length > 0) {
            obj.children = this.handleMenuList(item.pages)
          }
          arr.push(obj)
        })
      }
      return arr
    }
  }
}
</script>
<style>
.main {
  height: calc(100vh) !important;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.left_menu .logo_con {
  text-align: center;
}
.left_menu.ivu-layout-sider {
  height: 100%;
  background-color: #251100;
  overflow-y: auto;
}
.left_menu .ivu-menu .iconfont,
.ivu-dropdown-menu .ivu-dropdown-item .iconfont,
.top_breadcrumb .iconfont {
  display: inline-block;
  width: 16px;
}
.left_menu .ivu-menu .icon-neirongguanli {
  font-size: 14px;
}
.left_menu .collapsed-menu {
  display: none;
}
.left_menu .ivu-menu-dark {
  background: none;
}
.left_menu
  .ivu-menu-dark.ivu-menu-vertical
  .ivu-menu-opened
  .ivu-menu-submenu-title {
  background: #251100 !important;
}
.left_menu .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened {
  background: #180b00 !important;
}
.left_menu
  .ivu-menu-dark.ivu-menu-vertical
  .ivu-menu-submenu
  .ivu-menu-item-active,
.left_menu
  .ivu-menu-dark.ivu-menu-vertical
  .ivu-menu-item-active:not(.ivu-menu-submenu),
.left_menu
  .ivu-menu-dark.ivu-menu-vertical
  .ivu-menu-item-active:not(.ivu-menu-submenu):hover {
  background: #e86b00 !important;
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu),
.ivu-menu-dark.ivu-menu-vertical
  .ivu-menu-submenu-title-active:not(.ivu-menu-submenu) {
  color: #fff !important;
}
.ivu-dropdown .ivu-select-dropdown {
  width: auto;
}
.main .ivu-layout .layout-header-bar {
  background: #fff;
}
.sider_trigger {
  float: left;
}
/* 面包屑导航 */
.top_breadcrumb {
  float: left;
}
.top_breadcrumb .ivu-breadcrumb a {
  color: #bababa;
}
.top_breadcrumb .ivu-breadcrumb > span:first-child a,
.ivu-breadcrumb > span:last-child {
  color: #6e5d51;
}
.main .main_content {
  height: calc(100% - 60px);
  overflow: hidden;
}
.main_content .ivu-layout {
  height: 100%;
  overflow: hidden;
}
.content_wrap {
  min-width: 860px;
  /* padding: 15px 10px; */
  padding: 10px;
  height: calc(100% - 40px);
  overflow-y: auto;
}
.main_content .tag_wrap {
  background: #f0f0f0;
  height: 40px;
}
.tags-nav .ivu-tag-primary,
.tags-nav .ivu-tag-primary.ivu-tag-dot .ivu-tag-dot-inner {
  background: #ff7600;
}
/* 横向滚动条 */
/* .table_wrap{
  padding-bottom: 30px;
  overflow-x: auto !important;
  overflow-y: hidden !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/main/main.vue